import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconAmenitiesGarbageComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 6h18" />
        <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" fill="none" />
        <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" fill="none" />
        <line x1="10" x2="10" y1="11" y2="17" />
        <line x1="14" x2="14" y1="11" y2="17" />
      </svg>
    </SvgIcon>
  );
};

IconAmenitiesGarbageComponent.displayName = 'IconAmenitiesGarbage';

const IconAmenitiesGarbage = React.memo(IconAmenitiesGarbageComponent);

export default IconAmenitiesGarbage;
